import React from "react";
import { noTransaction } from "../../assets/images";

type Props = {
  title: string;
  description?: string;
  action?: React.ReactNode;
};

const EmptyState = ({ title, description, action }: Props) => (
  <div className="flex flex-col items-center justify-center gap-3 px-6 py-12">
    <img src={noTransaction} alt="" className="h-24 w-auto opacity-90" />
    <h3 className="font-sora text-[17px] font-bold text-foreground">{title}</h3>
    {description && (
      <p className="max-w-[380px] text-[14px] font-medium text-muted-foreground">
        {description}
      </p>
    )}
    {action}
  </div>
);

export default EmptyState;
